function GoogleAnalytics() {}

GoogleAnalytics.productImpression = function (elm, productData) {
    const eventName = 'ProductImpressions'
    const productImpressionEvent = dataLayer.find(item => item.event === eventName)
    if (!productImpressionEvent) {
        dataLayer.push({
            'event': eventName,
            'currencyCode': 'EUR',
            'ecommerce': {
                'impressions': [
                    productData
                ]
            }
        })
    } else {
        productImpressionEvent.ecommerce.impressions.push(productData)
    }
}

GoogleAnalytics.productClick = function (elm, productData, position) {
    productData.position = position
    dataLayer.push({
        'event': 'productClick',
        'currencyCode': 'EUR',
        'ecommerce': {
            'click': {
                'actionField': {'list':  'Assortiment'},
                'products': [
                    productData
                ]
            }
        },
        'eventCallback': function () {
            document.location = elm.href
        }
    })
}

/**
 * @deprecated Use GoogleAnalytics.addToCartGa4 instead
 * @param elm
 * @param productData
 */
GoogleAnalytics.addToCart = function (elm, productData) {
    dataLayer.push({
        'event': 'addToCart',
        'currencyCode': 'EUR',
        'ecommerce': {
            'add': {
                'products': [
                    productData
                ]
            }
        }
    })
}

GoogleAnalytics.removeFromCart = function (productData) {
    dataLayer.push({
        'event': 'removeFromCart',
        'currencyCode': 'EUR',
        'ecommerce': {
            'remove': {
                'products': [
                    productData
                ]
            }
        }
    })
}

GoogleAnalytics.beginCheckout = function (beginCheckoutData) {
    dataLayer.push(beginCheckoutData)
}

GoogleAnalytics.checkout = function (checkoutData) {
    dataLayer.push(checkoutData)
}

GoogleAnalytics.addShippingInfoData = function (addShippingInfoData) {
    dataLayer.push(addShippingInfoData)
}

GoogleAnalytics.addViewItemListData = function (addViewItemListData) {
    dataLayer.push(addViewItemListData)
}

GoogleAnalytics.addPaymentInfoData = function (addPaymentInfoData) {
    dataLayer.push(addPaymentInfoData)
}

GoogleAnalytics.addToCartGa4 = function (product) {
    dataLayer.push({
        'event': 'add_to_cart',
        'currency': 'EUR',
        'value': product.price,
        'items': [
            product
        ]
    })
}

export default GoogleAnalytics
